import StandardError from '../StandardError'

export default class HasTrackingData extends StandardError {
  constructor() {
    super(
      `"Hi pal, it appears there is tracking on this order. Click "VIEW TRACKING" above to view it."`
    )
  }
}
